import { render, staticRenderFns } from "./CSAdminApprovalList.vue?vue&type=template&id=3d36b74a&lang=pug&"
import script from "./CSAdminApprovalList.vue?vue&type=script&lang=js&"
export * from "./CSAdminApprovalList.vue?vue&type=script&lang=js&"
import style0 from "./CSAdminApprovalList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports